import React from "react";

import { useTranslation } from "utils";

import { MetaData } from "components";

import { PreLoginFooter } from "pages/app/soilsight-pre-login/components/PreLoginFooter";
import { PreLoginHeader } from "pages/app/soilsight-pre-login/components/PreLoginHeader";

type PreLoginLayoutProps = {
  children: React.ReactNode;
};

export const PreLoginLayout = ({ children }: PreLoginLayoutProps) => {
  const { t } = useTranslation("meta");

  return (
    <div className="soilsight-pre-login" data-testid="soilsight-pre-login">
      {/* Public flow, rendered outside MainPage: without this the tab keeps the last title set. */}
      <MetaData title={t("meta:soilSight.title")} />
      <PreLoginHeader />
      <main className="soilsight-pre-login__main">{children}</main>
      <PreLoginFooter />
    </div>
  );
};
